import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Box, Typography } from "@mui/material";
import Flex from "@/components/Flex";
import { HOME_CARE_SCREENERS } from "./HomeCareScreeningLayout";
import { ASS_ASSESSMENT } from "./constant-new-ass";

export type AssessmentCategory = "ECARE" | "HOME_CARE";

interface AssessmentCategoryPickerProps {
  onPick: (category: AssessmentCategory) => void;
}

const Card = ({
  icon,
  title,
  description,
  count,
  onClick,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  count: number;
  onClick: () => void;
}) => (
  <Box
    onClick={onClick}
    sx={{
      flex: 1,
      p: 2.5,
      border: "1px solid #e0e0e0",
      borderRadius: 2,
      cursor: "pointer",
      "&:hover": { borderColor: "primary.main" },
    }}
  >
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: 1.5,
        bgcolor: "#eef2fb",
        color: "primary.main",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 2,
      }}
    >
      {icon}
    </Box>
    <Typography fontWeight="bold">{title}</Typography>
    <Typography variant="body2" color="text.secondary" mt={0.5}>
      {description}
    </Typography>
    <Flex alignItems="center" mt={1.5} sx={{ color: "primary.main" }}>
      <Typography variant="body2" fontWeight="medium">
        {count} templates
      </Typography>
      <ChevronRightIcon fontSize="small" />
    </Flex>
  </Box>
);

// First step of New Screening Assessment: pick the eCareHealth screeners or
// the Home Care screeners.
const AssessmentCategoryPicker = ({
  onPick,
}: AssessmentCategoryPickerProps) => (
  <Box p={2}>
    <Typography variant="h6" fontWeight="bold">
      Choose an assessment type
    </Typography>
    <Typography variant="body2" color="text.secondary" mb={2}>
      Select a category to see its screening templates.
    </Typography>
    <Flex gap={2}>
      <Card
        icon={<AssignmentOutlinedIcon />}
        title="eCareHealth Assessments"
        description="Standardized clinical screeners — depression, anxiety and more"
        count={ASS_ASSESSMENT.length}
        onClick={() => onPick("ECARE")}
      />
      <Card
        icon={<HomeOutlinedIcon />}
        title="Home Care Assessments"
        description="Obesity and smoking screenings, with diabetic and annual wellness to follow"
        count={HOME_CARE_SCREENERS.length}
        onClick={() => onPick("HOME_CARE")}
      />
    </Flex>
  </Box>
);

export default AssessmentCategoryPicker;
